var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-box',{attrs:{"data":_vm.data,"spinning":_vm.spinning},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var issue = ref.record;
return [_c('issue-item',{key:issue.id,attrs:{"issue":issue,"active":_vm.activeId === issue.id},on:{"click":function($event){return _vm.viewDetail(issue)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }